/** CSV ダウンロード時のファイル名を生成する（例: chat-logs-2026-07-20260713-090503.csv） */
export function buildDownloadFilename(yearMonth: string, now: Date): string {
  const pad = (n: number): string => String(n).padStart(2, '0');
  const ts =
    `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}` +
    `-${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  return `chat-logs-${yearMonth}-${ts}.csv`;
}
